import { Box, Popover as MantinePopover, useMatches } from "@mantine/core";

import { Modal } from "@/components/elements";

import type { FC, ReactNode } from "react";

interface PopoverProps {
  popoverOpened: boolean;
  setPopoverOpened: React.Dispatch<React.SetStateAction<boolean>>;
  actionInPending: boolean;
  target: ReactNode;
  children: ReactNode;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Popover: FC<PopoverProps> = ({
  target,
  children,
  popoverOpened,
  setPopoverOpened,
  actionInPending,
  title,
  onClick,
}) => {
  const isMobile = useMatches({ base: true, sm: false });

  /* handlers */
  const handleClose = () => setPopoverOpened(false);

  const preventClickPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(e);
  };

  /* Mobile version */
  if (isMobile) {
    return (
      <>
        <Box onClick={(e) => preventClickPropagation(e)}>{target}</Box>
        <Modal
          fullScreen={false} // don't change this
          centered
          large
          title={title || ""}
          titleFontSize="1rem"
          onClick={(e) => preventClickPropagation(e)}
          opened={popoverOpened}
          onClose={handleClose}
          styles={{
            title: {
              paddingLeft: "4px",
            },
          }}
        >
          {children}
        </Modal>
      </>
    );
  }

  /* Desktop version */
  return (
    <>
      <MantinePopover
        opened={popoverOpened}
        onChange={setPopoverOpened}
        closeOnEscape={!actionInPending}
        onClose={handleClose}
        closeOnClickOutside={!actionInPending}
        withArrow
        width={300}
        position="right-start"
        shadow="md"
      >
        <MantinePopover.Target>
          <Box onClick={(e) => preventClickPropagation(e)}>{target}</Box>
        </MantinePopover.Target>

        <MantinePopover.Dropdown
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(e);
          }}
          p="lg"
        >
          {children}
        </MantinePopover.Dropdown>
      </MantinePopover>
    </>
  );
};

export default Popover;
